import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { UserRole } from '@openapi';

/**
 * Service for managing and emitting role change events.
 * This service provides an observable to notify subscribers about role changes.
 */
@Injectable({
  providedIn: 'root',
})
export class EventService {
  /**
   * Subject for emitting role change events.
   * @private
   */
  private readonly roleChangeSubject = new Subject<UserRole[]>();

  /**
   * Observable that emits role change events to subscribers.
   */
  public readonly roleChange$: Observable<UserRole[]> =
    this.roleChangeSubject.asObservable();

  /**
   * Emits a role change event with the new list of user roles.
   * @param userRoles - The new list of user roles to emit.
   */
  public emitRoleChange(userRoles: UserRole[]): void {
    this.roleChangeSubject.next(userRoles);
  }
}
